export const dateWiseOccColumns = [
  { Header: 'Sl. No.', accessor: 'Sl' },
  { Header: 'Hotel Name', accessor: 'PropertyName' },
  { Header: 'Customer Name', accessor: 'CustomerName' },
  { Header: 'Date and Time of Booking', accessor: 'BookingDateTime' },
  { Header: 'Checkin Date', accessor: 'CheckinDate' },
  { Header: 'Checkout Date', accessor: 'CheckoutDate' },
  { Header: 'Booking Reference No.', accessor: 'BookingRefNo' },
  { Header: 'No. of Rooms Booked', accessor: 'NoOfRooms' },
  { Header: 'Payment Mode', accessor: 'PaymentMode' },
  { Header: 'Bank Transaction/Cheque/DD/Card Swipe Number', accessor: 'TransactionNumber' },
  { Header: 'Transaction/Bill Date', accessor: 'BillDate' },
  { Header: 'Booking Source', accessor: 'BookingSource' },
  { Header: 'MR Number', accessor: 'MRNumber' },
  { Header: 'MR Date', accessor: 'MRDate' },
  { Header: 'Customer Mobile No.', accessor: 'CustomerMobile' },
  { Header: 'Base Amount', accessor: 'BaseAmount' },
  { Header: 'Booked By', accessor: 'BookedBy' },
  { Header: 'Tax Type', accessor: 'TaxType' },
  { Header: 'Tax Amount', accessor: 'TaxAmount' },
  { Header: 'Total Amount', accessor: 'TotalAmount', className: 'text-right' }
];
